import React from 'react'

const ModalButton = ({
  text,
  icon,
  onClick,
  backgroundColor,
  color = '#fff',
  border = 'none',
  margin = '.3rem 0 0 0',
  disabled = false,
}) => {
  return (
    <button
      type='button'
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '.8rem',
        padding: '.8rem .5rem',
        fontSize: '18px',
        border: border,
        borderRadius: '30px',
        backgroundColor: disabled ? '#CBCBCB' : backgroundColor,
        color: color,
        width: '100%',
        margin: margin,
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
      <div>{text}</div>
    </button>
  )
}

export default ModalButton
